import React from 'react';
import { Link } from 'react-router-dom';
import type { FooterColumn, FooterLink } from '../types';
import { LandingFooterBase, LandingBrandMark, type LandingFooterColumn } from '../../landing-system';

type Props = {
  footerColumns: FooterColumn[];
};

function isFooterLink(item: string | FooterLink): item is FooterLink {
  return typeof item === 'object' && item !== null && 'href' in item;
}

/**
 * Kloutsale footer — delegates structure to the shared LandingFooterBase
 * so Kloutforce/Katalag get the same shell. Brand-specific bits (the K
 * glyph, the brand name, the tagline, the © line) stay here so messaging
 * stays flexible per app. Legacy string entries in `footerColumns` are
 * filtered out (they were placeholder labels with no destination).
 */
export default function Footer({ footerColumns }: Props) {
  const columns: LandingFooterColumn[] = footerColumns.map((column) => ({
    heading: column.heading,
    links: column.links.filter(isFooterLink),
  }));

  return (
    <LandingFooterBase
      tone="dark"
      brand={
        <Link to="/" className="no-underline">
          <LandingBrandMark
            logoSrc="/brand/kloutsale-logo-dark.png"
            name="Kloutsale"
            tone="dark"
            size="sm"
          />
        </Link>
      }
      tagline="Multiply sales with a kloutforce of trusted commerce."
      columns={columns}
      copyright="© 2026 Kloutsale. All rights reserved."
    />
  );
}
